import "./style.scss";
import { NavLink, useSearchParams } from "react-router-dom";
import Dashboard from "../../dashboard/Dashboard";
import checkAll from "./images/check-all.png";
import { useEffect, useState } from "react";
import { Spinner } from "../../../components";
import {
  listPayoutByStatus,
  updatePayoutStatus,
} from "../../../services/payout.service";
import { IEmergency, PayoutResponse } from "../../reviews/types";
import showToast from "../../../utils/show.toast";
import {
  ArrowLeft,
  Calendar1Icon,
  CheckCheckIcon,
  DownloadIcon,
  SearchIcon,
} from "lucide-react";

interface IEmergencyData {
  isLoading: boolean;
  emergencyPay: IEmergency[];
}

export default function EmergencyPayoutTable() {
  const [emergenctData, setEmergencyData] = useState<IEmergencyData>({
    isLoading: true,
    emergencyPay: [],
  });

  const [isActive, setIsActive] = useState<boolean>(false);
  const [selectedWithdrawalIds, setSelectedWithdrawalIds] = useState<string[]>(
    []
  );

  const handleCheckboxChange = (id: string) => {
    setSelectedWithdrawalIds((prev) => {
      if (prev.includes(id)) {
        return prev.filter((teacherId) => teacherId !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const calculatePayoutAmount = (money: string) => {
    // const act = Number(withdrawal) - 8%

    const withdrawalAmount = parseFloat(money);

    if (isNaN(withdrawalAmount) || withdrawalAmount < 0) {
      return "invalid amount";
    }

    const payoutAmount = withdrawalAmount * 0.92;
    return payoutAmount.toFixed(2);
  };

  useEffect(() => {
    fetchEmergencyByStatus();
  }, []);

  const handleCheck = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const payload = { withdrawalIds: selectedWithdrawalIds, status: "paid" };
    if (payload.withdrawalIds.length === 0) {
      return;
    }

    try {
      const statusUpate = await updatePayoutStatus(
        "withdrawal/batch-status",
        payload
      );
      if (statusUpate.status !== "success") {
        showToast("Error marking status paid", false);
        return;
      }
      return showToast("Payout changed successfully!", true);
    } catch (error) {
      showToast("There was error marking payment paid.", false);
      return;
    }
  };

  const fetchEmergencyByStatus = async () => {
    try {
      const response = await listPayoutByStatus<PayoutResponse>(
        "withdrawal/emergency"
      );
      if (response.status !== "success") {
        setEmergencyData({ emergencyPay: [], isLoading: false });
        return;
      }
      setEmergencyData({ emergencyPay: response.result, isLoading: false });
    } catch (error) {
      showToast("There was an error listing payments...", true);
      setEmergencyData({ emergencyPay: [], isLoading: false });
      return;
    }
  };

  return (
    <Dashboard>
      <div className="emergency-header">
        <div className="emergency-title">
          <NavLink to="/payout/dashboard" className="back-link">
            <ArrowLeft className="back-icon" size={20} />
            <span>Emergency Requests</span>
          </NavLink>
        </div>
        <p className="emergency-date">
          <Calendar1Icon className="date-icon" />
          {new Date().toUTCString()}
        </p>
      </div>

      <div className="emergency-cards">
        <div className="card">
          <p>Total Withdrawal Amount</p>
          <h2>$0</h2>
        </div>
        <div className="card">
          <p>Total Payout Amount</p>
          <h2>$0</h2>
        </div>
        <div className="card">
          <p>Total Request</p>
          <h2>0</h2>
        </div>
      </div>

      <div className="emergency-actions">
        <div className="search-bar">
          <SearchIcon className="search-icon" />
          <input placeholder="Search by Email" />
        </div>
        <div className="buttons">
          <form onSubmit={handleCheck}>
            <button
              type="submit"
              className={`mark-paid ${isActive ? "active" : ""}`}
            >
              Mark as Paid
            </button>
          </form>
          <button className="download-btn">
            Download <DownloadIcon />
          </button>
        </div>
      </div>

      {emergenctData.isLoading ? (
        <Spinner />
      ) : (
        <div className="emergency-table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <CheckCheckIcon />
                </th>
                <th>Name</th>
                <th>Email</th>
                <th>Provider Type</th>
                <th>Withdrawal Amt</th>
                <th>Account Reference</th>
                <th>Payout Amount (USD)</th>
                <th>Status</th>
                <th>Request Date</th>
              </tr>
            </thead>
            <tbody>
              {emergenctData.emergencyPay.map((pay) => (
                <tr key={pay.teacherProfileId}>
                  <td>
                    <input
                      type="checkbox"
                      onChange={() => handleCheckboxChange(pay.withdrawalId)}
                    />
                  </td>
                  <td>
                    {pay.firstName} {pay.lastName} {pay.otherNames}
                  </td>
                  <td>{pay.email}</td>
                  <td>{pay.paymentMethodType}</td>
                  <td>{pay.amount} USD</td>
                  <td>
                    {pay.paymentMethodType === "paypal"
                      ? pay.paymentDetails.email
                      : pay.paymentDetails.payoneerId}{" "}
                    - {pay.paymentMethodType.toUpperCase()}
                  </td>
                  <td>{calculatePayoutAmount(pay.amount)} USD</td>
                  <td>
                    <span className={`status ${pay.status.toLowerCase()}`}>
                      {pay.status}
                    </span>
                  </td>
                  <td>{new Date(pay.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Dashboard>
  );
}
